function roundToTwoDecimals(value) {
  return Math.round((value + Number.EPSILON) * 100) / 100;
}
function isNumber(value) {
  return typeof value === 'number';
}
function isNumeric(value) {
  return typeof value === 'string' && !isNaN(+value) && !isNaN(parseFloat(value)) && value !== '';
}
/**
 * @param [value] The value to be parsed
 * @param [clearValue=false] Clear the value of non-numeric characters before parsing
 */
function stringToFloat(value, clearValue = false) {
  /* eslint-disable-next-line */
  if (clearValue) value = value.replace(/[^\p{N}\.]/u, '');
  if (typeof value !== 'string' || isNaN(parseFloat(value))) return value;
  return parseFloat(value);
}
/**
 * @param [value] The value to be parsed
 */
function stringToNumber(value) {
  if (!isNumeric(value)) return value;
  return Number(value);
}

export { isNumber, isNumeric, roundToTwoDecimals, stringToFloat, stringToNumber };
